var StaffMemberListDtoBuilder = /** @class */ (function () {
    function StaffMemberListDtoBuilder() {
        this.staffList = [];
    }
    StaffMemberListDtoBuilder.prototype.withStaffList = function (staffList) {
        this.staffList = staffList;
        return this;
    };
    StaffMemberListDtoBuilder.prototype.build = function () {
        return { staff: this.staffList };
    };
    return StaffMemberListDtoBuilder;
}());
export { StaffMemberListDtoBuilder };
var StaffMemberDtoBuilder = /** @class */ (function () {
    function StaffMemberDtoBuilder() {
        this.staffMember = {
            id: 'staffMember-id',
            fullName: 'staffMember name',
        };
    }
    StaffMemberDtoBuilder.prototype.withName = function (name) {
        this.staffMember.fullName = name;
        return this;
    };
    StaffMemberDtoBuilder.prototype.withId = function (id) {
        this.staffMember.id = id;
        return this;
    };
    StaffMemberDtoBuilder.prototype.build = function () {
        return this.staffMember;
    };
    return StaffMemberDtoBuilder;
}());
export { StaffMemberDtoBuilder };
//# sourceMappingURL=staff.dto.builder.js.map